// Local translations
export const T = {
  en_GB: {
    title: "Add assets by ISIN",
    description:
      "Paste ISIN codes with amounts, one per line. Format: ISIN,amount. Looking up names is optional — without a name, the ISIN is used as the description.",
    preview: "Preview:",
    cancel: "Cancel",
    lookupNames: "Lookup Names",
    addEntry: (count: number) => `Add ${count} Entry`,
    addEntries: (count: number) => `Add ${count} Entries`,
    lineErrors: {
      invalid_isin: "Not a valid ISIN",
      missing_amount: "Amount missing",
      invalid_amount: "Invalid amount",
    },
    nameNotFound: "Name not found",
    overLimit: "Over the asset row limit",
    lookupFailed: "Name lookup failed. The rows can still be added; try the lookup again later.",
  },
  nb_NO: {
    title: "Legg til eiendeler med ISIN",
    description:
      "Lim inn ISIN-koder med beløp, en per linje. Format: ISIN,beløp. Navneoppslag er valgfritt — uten navn brukes ISIN som beskrivelse.",
    preview: "Forhåndsvisning:",
    cancel: "Avbryt",
    lookupNames: "Slå opp navn",
    addEntry: (count: number) => `Legg til ${count} oppføring`,
    addEntries: (count: number) => `Legg til ${count} oppføringer`,
    lineErrors: {
      invalid_isin: "Ikke en gyldig ISIN",
      missing_amount: "Beløp mangler",
      invalid_amount: "Ugyldig beløp",
    },
    nameNotFound: "Fant ikke navn",
    overLimit: "Over grensen for antall eiendeler",
    lookupFailed:
      "Navneoppslaget feilet. Radene kan fortsatt legges til; prøv oppslaget igjen senere.",
  },
} as const;
